// extracted by mini-css-extract-plugin
export default {"card":"card__2Gjqh","cardImg":"cardImg__2YafW","cardContent":"cardContent__eTnl5","row":"row__29iL8","left":"left__207Sh","right":"right__LPXWa","cardTitle":"cardTitle__3qPA3","startingPrice":"startingPrice__19HaE","price":"price__2TVul","goToProductButton":"goToProductButton__2rQOs"};
    if(module.hot) {
      // 1788784378172
      var cssReload = require("../../../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  